import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "mail",
  "use": "mail-usage",
  "viewBox": "0 0 16 11",
  "content": "<symbol viewBox=\"0 0 16 11\" id=\"mail\"><path d=\"M8.02 6.597h.003c.121 0 .24-.036.337-.102l.026-.017.018-.011.304-.259L15.983.036A.085.085 0 0 0 15.915 0H.085a.08.08 0 0 0-.053.02l7.611 6.449a.59.59 0 0 0 .377.128zM0 .874v9.149l5.452-4.528L0 .874zm10.553 4.651l5.447 4.5V.905l-5.447 4.62zM8.822 6.994a1.239 1.239 0 0 1-.8.284c-.299 0-.583-.1-.799-.283L5.974 5.937 0 10.897v.016c0 .047.039.087.086.087h15.829c.046 0 .085-.04.085-.087v-.015l-5.969-4.93-1.209 1.026z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol